module.exports = __webpack_public_path__ + "img/times.740309e5.svg";